import { toast } from 'sonner';
import { addProduct, gradeItem } from 'services/api/product';
import { useAppStore } from '../store/appStore';
import { useAuthStore } from '../store/authStore';
import { useProductStore } from '../store/productStore';
import { useReceiptStore } from '../store/receiptStore';
import { GradeData, ProductLine, SubmitApiResult } from 'types';
import { SCREEN_TYPES } from 'utils/constants';

const onGradeComplete = (updatedProduct?: ProductLine): void => {
  const { setCurrentProduct } = useProductStore.getState();
  const { receiptData, setReceiptData } = useReceiptStore.getState();
  const { setCurrentScreen } = useAppStore.getState();
  if (updatedProduct) {
    setCurrentProduct(updatedProduct);
    // Update receiptData with the graded line
    if (receiptData) {
      const updatedLines =
        receiptData.lines?.map((line) =>
          line?.receipt_line === updatedProduct.receipt_line
            ? { ...line, ...updatedProduct, receipt_ind: 'y' }
            : line
        ) || [];
      setReceiptData({ ...receiptData, lines: updatedLines });
    }
  }
  setCurrentScreen(SCREEN_TYPES.DISPOSITION);
};

export const submitCurrentGradeItem = async (isRejected?: boolean): Promise<SubmitApiResult> => {
  const { user, stationId } = useAuthStore.getState();
  const {
    currentProduct: productLine,
    isProductNew,
    productCondition,
    setCurrentProduct,
  } = useProductStore.getState();
  const { receiptData, setReceiptData } = useReceiptStore.getState();

  try {
    const gradeData: GradeData = {
      user_id: user.id,
      station_id: stationId,
      transaction_id: productLine.transaction_id,
      receipt_line: productLine.receipt_line,
      is_new: isProductNew,
      product_condition: productCondition,
      upc: productLine.upc,
      vendor_id: productLine.vendor_id,
      exception_process: productLine.exception_process,
      disposition_stage: productLine.disposition_stage,
    };

    const result =
      productLine.expected_ind === 'y'
        ? await gradeItem(gradeData, isRejected)
        : await addProduct(gradeData);

    if (result?.responseState === 'confirmed') {
      toast.success('Item graded successfully');
      // Update product with disposition_stage from response
      const updatedProduct = {
        ...productLine,
        receipt_grade: result.receipt_grade,
        disposition_stage: result.disposition_stage,
        exception_process: result.exception_process,
        receipt_ind: 'y',
      } as ProductLine;
      onGradeComplete(updatedProduct);
    } else {
      toast.error(result?.responseMsg || 'Failed to grade item');
      return { success: false };
    }

    const updatedProduct = {
      ...productLine,
      receipt_grade: result.receipt_grade,
      disposition_stage: result.disposition_stage,
      exception_process: result.exception_process,
      receipt_ind: 'y',
    } as ProductLine;

    setCurrentProduct(updatedProduct);

    if (receiptData) {
      const updatedLines =
        receiptData.lines?.map((line) =>
          line?.receipt_line === updatedProduct.receipt_line
            ? { ...line, ...updatedProduct, receipt_ind: 'y' }
            : line
        ) || [];
      setReceiptData({ ...receiptData, lines: updatedLines });
    }

    return { success: true };
  } catch {
    toast.error('Network error. Please try again.');
    return { success: false };
  }
};
